import { render } from "./Statistikk.vue?vue&type=template&id=beed1eca"
import script from "./Statistikk.vue?vue&type=script&lang=js"
export * from "./Statistikk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__